import clsx from 'clsx';
import { Formik } from 'formik';
import { useState } from 'react';
import { TableCustomCell } from '../../../../component/table/components/TableCustomCell';

type Props = {
	className?: string;
	disabled?: boolean;
	textValue: string;
	textClassName?: string;
	editComponent: any;
};

const EditableCell = (props: Props) => {
	const { className, disabled, editComponent, textValue = '', textClassName } = props;

	const [enableEditing, setEnableEditing] = useState<boolean>(false);

	return (
		<TableCustomCell
			className={className}
			onDoubleClick={() => {
				if (disabled) return;
				
				setEnableEditing(true);
			}}
			data={
				<Formik initialValues={{}} onSubmit={() => {}}>
					{enableEditing ? (
						<>{editComponent({ setEnableEditing })}</>
					) : (
						<div
							className={clsx('spaces h-28', textClassName, {
								'pe-none': disabled,
							})}
						>
							{textValue}
						</div>
					)}
				</Formik>
			}
		/>
	);
};

export default EditableCell;
